import React, { useState } from "react";
import "./RegistrationPage.css";          // your existing CSS
import { db } from "../firebase";         // firebase config in src/firebase.js
import { collection, addDoc } from "firebase/firestore";

export default function RegistrationPage() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    category: "",
    gender: "",
    homeUniversity: "",
    email: "",
    password: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "students"), formData);
      alert("Registration successful!");
      setFormData({
        name: "",
        mobile: "",
        category: "",
        gender: "",
        homeUniversity: "",
        email: "",
        password: "",
      });
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Error saving data: " + error.message);
    }
  };

  const categories = [
    "Open", "OBC", "SC", "ST", "NT", "VJ", "SBC", "EWS", "Other",
  ];

  const districts = [
    "Ahmednagar","Akola","Amravati","Aurangabad","Beed","Bhandara","Buldhana",
    "Chandrapur","Dhule","Gadchiroli","Gondia","Hingoli","Jalgaon","Jalna",
    "Kolhapur","Latur","Mumbai City","Mumbai Suburban","Nagpur","Nanded",
    "Nandurbar","Nashik","Osmanabad","Palghar","Parbhani","Pune","Raigad",
    "Ratnagiri","Sangli","Satara","Sindhudurg","Solapur","Thane","Wardha",
    "Washim","Yavatmal",
  ];

  return (
    <div className="reg-container">
      <form className="reg-box" onSubmit={handleSubmit}>
        <h2 className="reg-title">Student Registration</h2>

        <label>Student Name</label>
        <input
          type="text"
          name="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Mobile Number</label>
        <input
          type="tel"
          name="mobile"
          placeholder="Enter mobile number"
          value={formData.mobile}
          onChange={handleChange}
          required
        />

        <label>Category</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
        >
          <option value="">Select Category</option>
          {categories.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <label>Gender</label>
        <select
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          required
        >
          <option value="">Select Gender</option>
          <option>Male</option>
          <option>Female</option>
          <option>Other</option>
        </select>

        <label>Home University (District)</label>
        <select
          name="homeUniversity"
          value={formData.homeUniversity}
          onChange={handleChange}
          required
        >
          <option value="">Select District</option>
          {districts.map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>

        <label>Email</label>
        <input
          type="email"
          name="email"
          placeholder="Enter email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Password</label>
        <input
          type="password"
          name="password"
          placeholder="Enter password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <button type="submit" className="reg-button">
          Register
        </button>
      </form>
    </div>
  );
}
